// Copyright 2016 Sorama B.V.

import { Unit, UnitType, dBUnit } from "units/Unit";
import { ZWeighting, AWeighting, BWeighting, CWeighting } from "units/Weighting";

export class Pressure extends UnitType {
    public static override typeName = "Pressure";

    public static milliPascal: Unit = new Unit("mPa", 1e-3, Pressure);
    public static pascal: Unit = new Unit("Pa", 1, Pressure);
    public static kiloPascal: Unit = new Unit("kPa", 1e3, Pressure);

    public static pascalRms: Unit = new Unit("Pa RMS", 1 / Math.sqrt(2), Pressure);

    public static milliBar: Unit = new Unit("mbar", 1e2, Pressure);
    public static bar: Unit = new Unit("bar", 1e5, Pressure);
    public static psi: Unit = new Unit("psi", 6894.76, Pressure);
    public static inh2o: Unit = new Unit("inH2O", 249.089, Pressure);

    public static dbSPL: dBUnit = new dBUnit("dB", " SPL", new ZWeighting(), Math.sqrt(2) * 2e-5, 20, 1, Pressure);
    public static dbASPL: dBUnit = new dBUnit("dB", " SPL", new AWeighting(), Math.sqrt(2) * 2e-5, 20, 1, Pressure);
    public static dbBSPL: dBUnit = new dBUnit("dB", " SPL", new BWeighting(), Math.sqrt(2) * 2e-5, 20, 1, Pressure);
    public static dbCSPL: dBUnit = new dBUnit("dB", " SPL", new CWeighting(), Math.sqrt(2) * 2e-5, 20, 1, Pressure);

    public static WeightedDbUnits = [Pressure.dbSPL, Pressure.dbASPL, Pressure.dbBSPL, Pressure.dbCSPL];
}
